import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const RadioDot = styled.div<{ isActive?: boolean }>`
  height: 12.5px;
  width: 12.5px;
  box-sizing: border-box;

  border: solid;
  border-width: ${({ isActive }) => (isActive ? '3px' : '2px')};
  border-color: ${({ isActive }) =>
    isActive ? themeStyle.selectionBlue : themeStyle.varInkLight};

  background-color: ${({ isActive }) =>
    isActive ? themeStyle.selectionBlue10 : themeStyle.transparent};
  transition:
    border-width 0.3s,
    border-color 0.3s,
    background-color 0.3s;
  border-radius: 100px;

  &:hover {
    border-width: 3px;
  }
`;
